import styled from 'styled-components';

export default styled.h2`
  text-transform: uppercase;
  margin-top: 0;
  font-family: TTNormsPro-Bold;
  font-size: 20px;
  line-height: 1.4;
`;
